// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { ConfigFileV1 } from '@taqueria/protocol/types';
import { ConfigFileV1 as ConfigFileV1Strict } from '@taqueria/protocol/out/types-strict';
import { configFileV1Schema } from '@taqueria/protocol/out/types-zod';

export type { ConfigFileV1Strict as ConfigFileV1 };

export const from = (input: unknown): ConfigFileV1Strict => {
	try {
		return configFileV1Schema.parse(input) as ConfigFileV1Strict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["ConfigFileV1 is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a ConfigFileV1.")
	}
    
};

export const create = (input: ConfigFileV1): ConfigFileV1Strict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, ConfigFileV1Strict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<ConfigFileV1Strict, '__type'>): FutureInstance<TaqError, ConfigFileV1Strict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: configFileV1Schema,
	schema: configFileV1Schema.transform(val => val as ConfigFileV1Strict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = configFileV1Schema;

export type t = ConfigFileV1Strict;
        